import { GET_WAREHOUSE, ADD_WAREHOUSE, UPDATE_WAREHOUSE, DELETE_WAREHOUSE, GET_ONE_WAREHOUSES } from "../types";
  
  const initialState = { list: [], single: null ,
    pagination: {
    limit: 10,
    nextPage: null,
    totalPages: 1,
    currentPage: 1,
    hasNextPage: false,
    previousPage: null,
    totalProducts: 0,
    hasPreviousPage: false,
  },};
  
  const reducer = (state = initialState, action) => {
    const { type, payload } = action;
  
    switch (type) {
      case GET_WAREHOUSE:
        return { ...state, list: payload.data , pagination: payload.pagination };
  
      case UPDATE_WAREHOUSE:
        return {
          ...state,
          list: state.list.map((item) =>
            item.id === payload.id ? payload : item
          ),
        };
  
      case ADD_WAREHOUSE:
        return {
          ...state,
          list: [payload, ...state.list],
        };
  
      case DELETE_WAREHOUSE:
        return {
          ...state,
          list: state.list.filter((item) => item.id !== payload.id),
        };
      
      case GET_ONE_WAREHOUSES:
        return { ...state, single: payload.id };
  
      default:
        return state;
    }
  };
  
  export default reducer;
  